import { GetReportsArgs, ReportSearchResult } from "types";

import API from "api/client";
import { envConfig } from "config";
import { toObject } from "@civicscience/chops";

const { reportsAPI } = envConfig;

/**
 *
 * Returns a list of reports.
 */
const getReports = async (options: GetReportsArgs): Promise<ReportSearchResult> => {
  const { query, orderBy, order, updatedAfter, updatedBefore, type, page = 1, size = 10 } = toObject(options);
  const { data } = await API.get<ReportSearchResult>(`${reportsAPI}`, {
    params: {
      query,
      orderBy,
      order,
      updatedAfter,
      updatedBefore,
      type,
      page,
      size,
    },
  });
  return data;
};

/**
 *
 * Returns a url for file download
 */
const getReport = async (uuid: string): Promise<string> => {
  const { data } = await API.get<string>(`${reportsAPI}${uuid}`);
  return data;
};

export default {
  list: getReports,
  get: getReport,
};
